import { useState, useEffect } from 'react';

import usePaginator from '../../../theme/Component/usePaginator';
import useModal, { MODAL_LG, MODAL_md } from '../../../theme/Component/hooks/useModal';
import { _DashBoard } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { SelectProccessTypeConstants } from '../../../erp/cellEditor/CashRequest/FactoryDocument/SelectProccessTypeConstants';
import { AccountEditor } from '../../../editor/AccountEditor';
import { BasicButton } from '../../../theme/Component/BasicButton';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const KpiDashEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_DashBoard)
    const [id, setID] = useState(null);
    const [regexStr, setregexStr] = useState<any>(null)
    const [form, setForm] = useState<any>({
        Account: null
    })
    const [processType, setprocessType] = useState<number>(null)
    const modal = useModal("Tablero de Control", MODAL_md);
    const paginador = usePaginator();
    const modalkpi = useModal("KPI", MODAL_LG);
    useEffect(() => {
        getLista();
    }, [paginador.page])
    useEffect(() => {
        setID(idSelector)
    }, [idSelector])



    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDDashBoard == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getDashBoardCatalog(processType, null, regexStr, form.Account, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }

    const head = [
        { title: 'ID', property: 'IDDashBoard', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha Creacion', property: 'Since', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Tablero de Control"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <SelectProccessTypeConstants idSelector={processType} onChange={(e) => { setprocessType(e) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor idAccount={form.Account} onChange={(e: any) => { setForm({ ...form, "Account": e.IDAccount }) }} label="Usuario de Tablero de Control" />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                            Consultar
                        </BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDDashBoard); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
            </Modal>
        </>
    )
}